import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  GetUsersParams,
} from '../interfaces/get-users';
import { RequestError } from '../../../interfaces/error.interface';
import { GetUserResponse } from '../interfaces/get-user';
import { User } from '../../../interfaces/user.interface';
import { GetCompaniesResponse } from '../interfaces/get-companies';
import { UserCompany } from '../../../interfaces/userCompany.interface';

export interface UserState {
  users: User[];
  user: User | null;
  options: GetUsersParams;
  companies: UserCompany[];
  errorCode: number | null;
}

const initialState: UserState = {
  users: [],
  user: null,
  options: {
    active: true
  },
  companies: [],
  errorCode: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUsersInitApiAction: (state) => {
      state.errorCode = null;
    },
    getUsersSuccessApiAction: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
    },
    getUsersFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getUserInitApiAction: (state) => {
      state.errorCode = null;
      state.user = null;
    },
    getUserSuccessApiAction: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    getUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    postUserSuccessApiAction: () => {},
    postUserFailuireApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putUserInitApiAction: () => {},
    putUserSuccessApiAction: () => {},
    putUserFailuireApiAction: () => {},
    putBlockUserInitApiAction: () => {},
    putBlockUserSuccessApiAction: () => {},
    putBlockUserFailuireApiAction: () => {},
    putUnblockUserInitApiAction: () => {},
    putUnblockUserSuccessApiAction: () => {},
    putUnblockUserFailuireApiAction: () => {},
    deleteUserInitApiAction: () => {},
    deleteUserSuccessApiAction: () => {},
    deleteUserFailureApiAction: (state, action: PayloadAction<{ errorCode: number }>) => {
      state.errorCode = action.payload.errorCode;
    },
    getCompaniesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getCompaniesSuccessApiAction: (state, action: PayloadAction<GetCompaniesResponse>) => {
      state.companies = action.payload.companies;
    },
    getCompaniesFailureApiAction: (state,action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    setOptionsAction: (state, action: PayloadAction<GetUsersParams>) => {
      state.options = action.payload;
    },
    resetOptionsAction: (state) => {
      state.options = {
        active: true
      };
    },
    userClearAction: (state) => {
      state.users = [];
      state.user = null;
      state.companies = [];
      state.errorCode = null;
    },
  },
});

export const {
  getUsersInitApiAction,
  getUsersSuccessApiAction,
  getUsersFailureApiAction,
  getUserInitApiAction,
  getUserSuccessApiAction,
  getUserFailureApiAction,
  postUserInitApiAction,
  postUserSuccessApiAction,
  postUserFailuireApiAction,
  putUserInitApiAction,
  deleteUserInitApiAction,
  deleteUserSuccessApiAction,
  deleteUserFailureApiAction,
  putUserSuccessApiAction,
  putUserFailuireApiAction,
  putBlockUserInitApiAction,
  putBlockUserSuccessApiAction,
  putBlockUserFailuireApiAction,
  putUnblockUserInitApiAction,
  putUnblockUserSuccessApiAction,
  putUnblockUserFailuireApiAction,
  getCompaniesInitApiAction,
  getCompaniesSuccessApiAction,
  getCompaniesFailureApiAction,
  setOptionsAction,
  resetOptionsAction,
  userClearAction,
} = userSlice.actions;

export default userSlice.reducer;
